import { useCallback, useEffect, useState } from 'react';

import useDelayFn from '~hooks/useDelayFn';
import { AssetId } from '~modules/media-library/model/Asset';
import { ConfirmDeleteModal } from '~modules/media-library/view/Contribute/ConfirmDelete/ConfirmDeleteModal';

export function ConfirmDeleteModalController({
  assetId,
  onClose,
  onDeleteSuccess,
}: {
  assetId: AssetId;
  onClose: () => void;
  onDeleteSuccess: () => void;
}) {
  const delayedOnClose = useDelayFn(onClose, 500);
  const delayedOnDeleteSuccess = useDelayFn(onDeleteSuccess, 500);
  const [isOpen, setIsOpen] = useState(false);

  // open modal when settings are loaded
  useEffect(() => {
    setIsOpen(Boolean(assetId));
  }, [assetId]);

  // Handler: close dialog, but delay the closing to have smoother transitions
  const handleOnClose = useCallback(() => {
    setIsOpen(false);
    delayedOnClose();
  }, [delayedOnClose]);
  const handleOnDeleteSuccess = useCallback(() => {
    setIsOpen(false);
    delayedOnDeleteSuccess();
  }, [delayedOnDeleteSuccess]);

  return (
    <ConfirmDeleteModal
      isOpen={isOpen}
      onClose={handleOnClose}
      onDeleteSuccess={handleOnDeleteSuccess}
      assetId={assetId}
    />
  );
}
